import { render, staticRenderFns } from "./supplierInfoMst.vue?vue&type=template&id=92a7d4f2&scoped=true"
import script from "./supplierInfoMst.vue?vue&type=script&lang=js"
export * from "./supplierInfoMst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a7d4f2",
  null
  
)

export default component.exports